import { render, staticRenderFns } from "./MainCollapse.vue?vue&type=template&id=c307344a&scoped=true"
import script from "./MainCollapse.vue?vue&type=script&lang=js"
export * from "./MainCollapse.vue?vue&type=script&lang=js"
import style0 from "./MainCollapse.vue?vue&type=style&index=0&id=c307344a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c307344a",
  null
  
)

export default component.exports